import React, { useState,forwardRef, useImperativeHandle } from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import TextWithInputs from 'src/pages/reportUsage/common/textWithInputs/TextWithInputs';
import QuantityCheckboxes from './QuantityCheckboxes';
import QuantityInputBoxes from './QuantityInputBoxes';
import DeleteLight from 'src/assets/images/DeleteLight.svg';
import AlertMsg from 'src/pages/reportUsage/common/AlertMsg';
import { sizes } from 'src/styles/Media.styled';
import media from 'src/styles/Media.styled';
import { getLotSerialInputPlaceHolder } from 'src/pages/reportUsage/utils/dataModificaionUtil';
import styled from 'styled-components';
import {
    isIpad,
    isLandscape,
    isMobileDevice,
    isMobileView,
    isSmallIOSDevice,
} from 'src/utils/util';
import Select from 'src/common/refactoredComponents/select/Select';
import CustomLabel from 'src/pages/reportUsage/common/customLabel/CustomLabel.jsx';
import { useTranslation } from 'react-i18next';
import { StyledDiv } from '../../../../consignmentBilling/components/billing/BillingContainer.styled';
import Checkbox from 'src/common/refactoredComponents/checkbox/Checkbox';
import { BROWN_FONT_COLOR, X_SMALL_TEXT_PX } from 'src/styles/fonts/MCFontConstants';
import { displayCheckbox } from 'src/pages/reportUsage/utils/eventHandlerUtil';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

// eslint-disable-next-line react/display-name
const LotSerialQtyInput = forwardRef((props, ref) => {
    const {
        item,
        index,
        lotItem,
        lotItemIdx,
        addSerialNumber,
        lotSerialValueEntered,
        showTopLabel,
        deleteItem,
        showBundlefromTableList,
        isChildItem,
        isFromMobileView,
        vendorCaseErrorRedirection,
        onIsSerialUnknown = () => {},
    } = props;
    const { t } = useTranslation();
    const deleteBtnHeightWidth = showTopLabel
        ? '32px !important'
        : '40px !important';
    const deleteBtnHeight = '40px !important';
    const usageDetails = useSelector(
        (state) => state.reportUsageRootReducer.usageDetails
    );
    const bottomLabelClickHandler = () => {
        if (item.isBundleItem) {
            showBundlefromTableList(true, index, item.cfn,item?.unqId);
        } else {
            addSerialNumber(item, index);
        }
    };

    useImperativeHandle(ref, () => ({
        bottomLabelClickHandler,
    }));

    const [showClear, setShowClear] = useState(false);
    const [lot, setLot] = useState('');

    const isIpadPortrait = () => {
        if (isIpad()) {
            if (isLandscape()) {
                return false;
            }
            return true;
        }
        return false;
    };

    useEffectWithErrorLogging(() => {
        setLot(lotItem?.lotSerialUnknown ? '' : lotItem.Serial ? lotItem.Serial : '');
        setShowClear(lotItem.Serial ? true : false);
    }, [lotItem]);
     useEffectWithErrorLogging(() => {
         setLot(
             lotItem?.lotSerialUnknown
                 ? ''
                 : lotItem.Serial
                 ? lotItem.Serial
                 : ''
         );
         setShowClear(lotItem.Serial ? true : false);
     }, [item]);

const placeholder = getLotSerialInputPlaceHolder(item);
    return (
        <>
            <div
                key={lotItem.id}
                style={{
                    display: 'flex',
                    paddingBottom: '10px',
                    paddingLeft:
                        isFromMobileView &&
                        item.isBundleItem &&
                        window.innerWidth <= sizes.mobileDevice &&
                        '25px',
                }}
            >
                {item.isUnidRodItem && item.batches?.length > 0 ? (
                    <StyledDivForBatches paddingRight={'16px'}>
                        {window.innerWidth <= sizes.smalDevice && (
                            <CustomLabel
                                fSize={'12px!important'}
                                color="#140F4B"
                                opacity="70%"
                                label={
                                    item?.cfn?.startsWith('S33')
                                        ? t(
                                              'reportUsage.record.reportPayment.LotSerialRPQtyInput.vendorCaseID'
                                          )
                                        : t('reportUsage.itemList.lotorserial')
                                }
                            />
                        )}
                        <Select
                            id="reportUsage-lotSerialQtyInput-itemList-batches"
                            // value={lot}
                            value={
                                lotItem?.lotSerialUnknown ? '' : lot ? lot : ''
                            }
                            
                            options={item.batches}
                            name={'batches'}
                            onChange={(e) => {
                                lotSerialValueEntered(
                                    e,
                                    item,
                                    index,
                                    lotItem,
                                    lotItemIdx
                                );
                                setLot(e.batches);
                                setShowClear(e.batches?.length > 0);
                            }}
                            placeholder={getLotSerialInputPlaceHolder(
                                item,
                                lotItem
                            )}
                            borderRadius={'6px'}
                            border={'1.5px solid #EBEDED'}
                            width={'140px'}
                            editable={true}
                            showClear={showClear}
                            crossIconMargin={'-5px'}
                            showOnFocus={true}
                        />
                    </StyledDivForBatches>
                ) : (
                    <TextWithInputs
                        styleObj={
                            window.innerWidth <= sizes.mobileDevice
                                ? {
                                      marginRight:
                                          isFromMobileView &&
                                          item.isBundleItem &&
                                          !isChildItem &&
                                          '34px',
                                  }
                                : { paddingRight: '12px' }
                        }
                        width={
                            isSmallIOSDevice()
                                ? 'auto'
                                : isMobileDevice()
                                ? 'auto'
                                : isIpadPortrait()
                                ? '160px'
                                : '140px'
                        }
                        inputHeight={'40px'}
                        xs={6}
                        lg={6}
                        md={6}
                        name={'Serial'}
                        topLabel={
                            showTopLabel &&
                            lotItemIdx === 0 && (
                                <React.Fragment>
                                    <span>
                                        {item?.cfn?.startsWith('S33')
                                            ? t(
                                                  'reportUsage.record.reportPayment.LotSerialRPQtyInput.vendorCaseID'
                                              )
                                            : t(
                                                  'reportUsage.itemList.lotorserial'
                                              )}
                                    </span>
                                    {(placeholder.includes('Req') ||
                                        placeholder.includes('要求')) && (
                                        <span
                                            style={{
                                                color: '#ED002A',
                                                paddingLeft: '3px',
                                            }}
                                        >
                                            *
                                        </span>
                                    )}
                                </React.Fragment>
                            )
                        }
                        // added back as a part of defect 21622
                        //Removed lotSerial link as per 1115 story
                        // Show bottomLabel only when checkbox is NOT present
                        bottomLabel={
                            !item.isInvalidItemMsg &&
                            item.lotSerial.length - 1 === lotItemIdx &&
                            !(item?.lotSerialUnknownApplicable &&  (item?.isSerialRequired || item?.isBatchRequired)) &&
                            (item.isBundleItem || item.materialType === 'DIEN'
                                ? isFromMobileView ||
                                  item.materialType === 'DIEN'
                                    ? ''
                                    : '+' + t('reportUsage.addItems.title')
                                : '+' + t('reportUsage.itemList.lotorserial'))
                        }
                        bottomLabelFontSize={'13px'}
                        bottomFontWeight={'normal'}
                        bottomLabelFontFamily={'AvenirNextWorld Regular'}
                        placeholder={getLotSerialInputPlaceHolder(
                            item,
                            lotItem
                        )}
                        inputDisabled={
                            item.isBundleItem ||
                            (item?.cfn?.startsWith('S33') &&
                                usageDetails?.vendorCaseId?.startsWith(
                                    'UH_'
                                )) ||
                            (item?.cfn?.startsWith('S33') &&
                                usageDetails?.vendorCaseId?.startsWith('AH_'))
                        }
                        onLabelClick={bottomLabelClickHandler}
                        onkeyUp={(e) =>
                            lotItem?.lotSerialUnknown!=true &&
                            lotSerialValueEntered(
                                e,
                                item,
                                index,
                                lotItem,
                                lotItemIdx
                            )
                        }
                        lotSerial={true}
                        defaultValue={
                            lotItem?.lotSerialUnknown
                                ? ''
                                : lotItem.Serial
                               
                        }
                            value={lotItem?.lotSerialUnknown ? '' : lotItem.Serial}
                        isBundleItem={item.isBundleItem}
                        cursor={'pointer'}
                        errorMessages={[
                            lotItem?.isInvalidQtyMsg
                                ? lotItem.isInvalidQtyMsg
                                : false,
                            lotItem?.isInvalidLotSerialMsg
                                ? lotItem.isInvalidLotSerialMsg
                                : false,
                        ]}
                        inputBorder={
                            lotItem.isInvalidLotSerialMsg?.length > 0 &&
                            '2px solid #FACFD6'
                        }
                        errorMessageWidth={
                            item?.cfn?.startsWith('S33')
                                ? isMobileDevice()
                                    ? 'calc(100vw - 14vw)'
                                    : isIpad() && isLandscape()
                                    ? 'calc(100vw - 68vw)'
                                    : 'calc(100vw - 58vw)'
                                : lotItem?.isInvalidQtyMsg
                                ? lotItem.isInvalidQtyMsg.includes(
                                      'not allowed for Fee items'
                                  )
                                    ? isMobileDevice()
                                        ? 'calc(100vw - 25vw)'
                                        : isIpad() && isLandscape()
                                        ? 'calc(100vw - 75vw)'
                                        : 'calc(100vw - 68vw)'
                                    : isIpad() && isLandscape()
                                    ? '280px'
                                    : ''
                                : ''
                        }
                        linkedSstref={
                            lotItem?.isInvalidLotSerialMsg
                                ? lotItem?.isInvalidLotSerialMsg?.includes(
                                      'discard'
                                  ) && item?.cfn?.startsWith('S33')
                                    ? lotItem?.linkedSstref
                                    : ''
                                : ''
                        }
                        vendorCaseErrorRedirection={vendorCaseErrorRedirection}
                        position={item?.cfn?.startsWith('S33') && 'relative'}
                    />
                )}
                <ListActionContent>
                    <div
                        style={{
                            width:
                                window.innerWidth >= sizes.mobileDevice &&
                                sizes.isIpad &&
                                !item.isBundleItem
                                    ? '155px'
                                    : '125px',
                            display: 'flex',
                            justifyContent:
                                window.innerWidth <= sizes.mobileDevice
                                    ? isChildItem
                                        ? 'space-evenly'
                                        : 'space-between'
                                    : 'space-between',
                            marginLeft:
                                window.innerWidth <= sizes.mobileDevice &&
                                item.isBundleItem &&
                                '-10px',
                            flexWrap: 'wrap',
                            padding:
                                window.innerWidth >= sizes.mobileDevice &&
                                window.innerWidth <= sizes.mediumDevice &&
                                isChildItem &&
                                '0 0 0 14px',
                            paddingLeft: '5px',
                            alignItems:   window.innerWidth > sizes.mobileDevice  && window.innerWidth > sizes.mediumDevice ? 'center' : '',
                            // paddingTop: showTopLabel ? '10px' : '0px',
                            gap: isIpad() && isLandscape() ? '8px' : '0px',
                        }}
                        className={'list-action-wrapper'}
                    >
                        {(item.salesOrg !== 'S030' ||
                            item.salesOrg === '' ||
                            !item.salesOrg) &&
                        !displayCheckbox(item) ? (
                            <QuantityInputBoxes
                                item={item}
                                index={index}
                                lotItem={lotItem}
                                lotItemIdx={lotItemIdx}
                                lotSerialValueEntered={lotSerialValueEntered}
                                showTopLabel={showTopLabel && lotItemIdx === 0}
                                isChildItem={isChildItem}
                            />
                        ) : (
                            <QuantityCheckboxes
                                item={item}
                                index={index}
                                lotItem={lotItem}
                                lotItemIdx={lotItemIdx}
                                lotSerialValueEntered={lotSerialValueEntered}
                                showTopLabel={showTopLabel && lotItemIdx === 0}
                                isChildItem={isChildItem}
                                padding={(window.innerWidth <= sizes.mediumDevice) ? '10px 0 0 10px' : '0 0 0 10px'}
                            />
                        )}

                        <Box
                            component={Button}
                            aria-controls="simple-menu-1"
                            aria-hospopup="true"
                            size="small"
                            width={deleteBtnHeightWidth}
                            height={deleteBtnHeight}
                            minWidth={deleteBtnHeightWidth}
                            minHeight={deleteBtnHeight}
                            // border="1px solid #EBEBEB"
                            //marginRight={!item.isBundleItem && '-5px'}
                            marginTop={
                                isMobileDevice()
                                    ? showTopLabel &&
                                      (lotItemIdx === 0 ? '15px' : '5px')
                                    : isIpad()
                                    ? isLandscape()
                                        ? '0px'
                                        : lotItemIdx === 0
                                        ? '15px !important'
                                        : '8px !important'
                                    : (window.innerWidth <= sizes.mediumDevice) ? '15px' : '0px'
                                    // : displayCheckbox(item) ? '7px !important' : '0px'
                            }
                            borderRadius={6}
                            onClick={() =>
                                deleteItem(lotItem.id, index, lotItemIdx)
                            }
                            marginRight={
                                isMobileDevice()
                                    ? isChildItem
                                        ? '1px'
                                        : item.isBundleItem
                                        ? '0px'
                                        : '0px'
                                    : isIpad()
                                    ? isChildItem
                                        ? '-35px'
                                        : '-44px'
                                    : item.isBundleItem
                                    ? '5px'
                                    : '0'
                            }
                            //marginLeft={'18px'}
                            className={'delete-button-box'}
                        >
                            <img
                                src={DeleteLight}
                                height={showTopLabel ? 20 : 24}
                                width={showTopLabel ? 20 : 24}
                            />
                        </Box>
                    </div>
                </ListActionContent>
            </div>
            {item?.lotSerialUnknownApplicable &&  (item?.isSerialRequired ||item?.isBatchRequired) && (
                <>
                    <StyledDiv marginLeft={'28.5%'} margin={'5px 0px 5px 0px'}>
                        <Checkbox
                            label={t('reportUsage.lotSerialUnknown')}
                            checked={
                                lotItem?.lotSerialUnknown
                                    ? lotItem?.lotSerialUnknown
                                    : !item?.lotSerialUnknownApplicable
                            }
                            onCheckboxSelectionChange={() =>
                                onIsSerialUnknown(
                                    item,
                                    index,
                                    lotItem?.lotSerialUnknown === true ||
                                        lotItem?.lotSerialUnknown === false
                                        ? !lotItem?.lotSerialUnknown
                                        : item?.lotSerialUnknownApplicable,
                                    lotItemIdx,
                                    lotItem
                                )
                            }
                            id="reportUsage-record-itemsList-LotSerialQtyInput-lotSerialUnknownCheckbox"
                            margin={'0px 8px 0px 0px'}
                            labelStyleObj={{
                                fontSize: X_SMALL_TEXT_PX,
                                color: BROWN_FONT_COLOR,
                            }}
                            background={'none'}
                            checkboxBorder={'1.5px solid #555555'}
                            alignItemDirection={'center'}
                            hoverEffect={'false'}
                            disableFocusEffect={'true'}
                        />
                    </StyledDiv>
                    {/* Show '+Lot/Serial' link below checkbox for mobile and iPad only */}
                    {!item.isInvalidItemMsg &&
                        item.lotSerial.length - 1 === lotItemIdx &&
                        window.innerWidth <= sizes.mediumDevice && (
                            <StyledDiv marginLeft={'28.5%'} margin={'15px 0px 5px 0px'}>
                                <CustomLabel
                                    fSize={'13px'}
                                    fontFamily={'AvenirNextWorld Regular'}
                                    color="#1010EB"
                                    cursor={'pointer'}
                                    opacity={1}
                                    label={
                                        item.isBundleItem || item.materialType === 'DIEN'
                                            ? '+' + t('reportUsage.addItems.title')
                                            : '+' + t('reportUsage.itemList.lotorserial')
                                    }
                                    onLabelClick={bottomLabelClickHandler}
                                    paddingTop={'0px'}
                                    paddingLeft={'0px'}
                                    letterSpacing={'-0.11px'}
                                    fWeight={'normal'}
                                />
                            </StyledDiv>
                        )}
                </>
            )}
            {(item.noItemInBundleErr ===
                t('reportUsage.itemTableErrorMessages.Bundle') ||
                (item.isUnidRodItem &&
                    item.batches?.length > 0 &&
                    (lotItem?.isInvalidQtyMsg?.length > 0 ||
                        lotItem?.isInvalidLotSerialMsg?.length > 0))) && (
                <ErrorMsgContainer minWidth={!isMobileView() && '170px'}>
                    <AlertMsg
                        message={
                            item.noItemInBundleErr ||
                            lotItem?.isInvalidQtyMsg ||
                            lotItem?.isInvalidLotSerialMsg
                        }
                    />
                </ErrorMsgContainer>
            )}
        </>
    );
});

export default LotSerialQtyInput;

export const ErrorMsgContainer = styled.div`
    display: flex;
    min-width: ${(props) => props.minWidth};
    width: ${(props) => props.width};
    word-break: ${(props) => props.breakWord};
    padding: ${(props) => props.padding};
`;

const StyledDivForBatches = styled.div`
    display: block;
    padding-right: ${({ paddingRight }) => paddingRight};
`;

export const ListActionContent = styled.div`
    .list-action-wrapper {
        width: 155px !important;

        @media screen and (min-device-width: 1360px) and (max-device-width: 1370px) and (min-device-height: 1020px) and (max-device-height: 1130px) and (orientation: landscape) {
            width: 125px !important;
            flex-wrap: nowrap !important;
            gap: 8px !important;
        }
        ${media.mediumDevice`
            width: 145px !important;
        `}

        // @media screen and (min-device-width: 800px) and (max-device-width: 820px) and (min-device-height: 1070px) and (max-device-height: 1090px) and (orientation: portrait) {
        //     width: 125px !important;
        // }

        ${media.smalDevice`
            width: 140px !important;            
        `}

        ${media.mobileDevice`
            width: 160px !important;
        `}
        
        @media only screen and (max-device-width: 375px) {
            width: 138px !important;
        }

        .delete-button-box {
            align-self: flex-end;
            @media screen and (min-device-width: 1360px) and (max-device-width: 1370px) and (min-device-height: 1020px) and (max-device-height: 1130px) and (orientation: landscape) {
                margin-top: 0px !important;
                margin-right: 0px !important;
                margin-left: 0px !important;
            }
        }
    }
`;
